import React, { useRef } from "react";
import { Carousel, CarouselItem, CarouselContent, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import ProductCard from "./product-card";
import Autoplay from "embla-carousel-autoplay";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useMediaQuery } from "@/hooks/use-media-query";

export default function ExploreRecommendations() {
  const products = [
    {
      id: 1,
      title: "Product 1",
      price: 100000,
      image:
        "https://plus.unsplash.com/premium_photo-1683917067988-1b0323c3b574?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 1 details",
    },
    {
      id: 2,
      title: "Product 2",
      price: 200000,
      image:
        "https://images.unsplash.com/photo-1615874959474-d609969a20ed?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 2 details",
    },
    {
      id: 3,
      title: "Product 3",
      price: 300000,
      image:
        "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YmVkcm9vbSUyMGludGVyaW9yfGVufDB8fDB8fHww",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 3 details",
    },
    {
      id: 4,
      title: "Product 4",
      price: 400000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 4 details",
    },
    {
      id: 5,
      title: "Product 5",
      price: 500000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 5 details",
    },
    {
      id: 6,
      title: "Product 6",
      price: 600000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 6 details",
    },
    {
      id: 7,
      title: "Product 4",
      price: 400000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 7 details",
    },
    {
      id: 8,
      title: "Product 5",
      price: 500000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 8 details",
    },
    {
      id: 9,
      title: "Product 6",
      price: 600000,
      image:
        "https://images.unsplash.com/photo-1633948393301-d43e3ec0e5cd?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      noOfReviews: 100,
      details: "Product 9 details",
    },
  ];

  const autoplay = useRef(Autoplay({ delay: 2100, stopOnInteraction: false }));
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <Carousel
      opts={{
        align: "start",
      }}
      plugins={[autoplay.current]}
      onMouseEnter={() => autoplay.current.stop()}
      onMouseLeave={() => autoplay.current.play()}
      className='w-full'
    >
      <CarouselContent className='-ml-7 rounded-lg'>
        {products.map((product) => (
          <CarouselItem key={product.id} className='basis-2/3 pl-7 md:basis-1/2 lg:basis-1/3'>
            <ProductCard size={isMobile ? "lg" : "lg"} {...product} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className='mt-3 hidden items-center justify-center gap-6 md:flex'>
        <CarouselPrevious
          variant='ghost'
          customIcon={<ArrowLeftIcon className='size-5 stroke-[3px]' />}
          className='disbled:text-black/50 text-primary relative top-0 left-0 translate-y-0'
        />
        <CarouselNext
          variant='ghost'
          customIcon={<ArrowRightIcon className='size-5 stroke-[3px]' />}
          className='disbled:text-black/50 text-primary relative top-0 left-0 translate-y-0'
        />
      </div>
    </Carousel>
  );
}
